import { createRoute } from "@tanstack/react-router";

import { brandRoute } from "../../platform/routes";
import { librarySearch } from "./library-search";
import { LibraryScreen } from "./LibraryScreen";

/** The brand's files (S1); the brand is the URL's, as every asset route's is. */
export const libraryRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "library",
  validateSearch: (search) => librarySearch.parse(search),
  component: LibraryScreen,
});
